// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"9925699f","196":"7835d9e5","214":"d9414819","281":"d8b83418","405":"7b73c877","577":"ffc6928a","690":"370216eb","729":"207a561f","859":"86a13be7","926":"7ba2652a"}[chunkId] + ".chunk.js";
};